<template>
  <div class="stageHolder">
    <div class="child" :style="{ height: lineheight + 'px' }">
      <div @contextmenu.prevent="" class="childTitle stageTitle" :style="{ top: lineheight - 16 + 'px' }">
        {{ $t('Diary') }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'DiaryTitle',
  data: () => {
    return {};
  },
  props: ['lineheight', 'diary', 'showHiddenStages'],
  methods: {
    ...mapActions([]),
  },
  computed: {
    ...mapGetters(['currentProject', 'hasPropertyPermissions', 'viewSettings']),
  },
  filters: {},
  components: {},
  mounted: function () {},
  beforeDestroy() {},
};
</script>

<style scoped>
.stageHolder {
  padding-left: 10px;
  text-transform: uppercase;
  margin-top: 10px;
}

.stageHolder input {
  text-transform: uppercase;
}

.stagePartPar {
  background: transparent;
  border: 3px solid black;
  border-radius: 0px;
  border-bottom: 0px;
}

.stageTitle {
  font-weight: bold;
}

.childTitle {
  position: relative;
  white-space: nowrap;
  height: 16px;
  display: inline-block;
  z-index: 100;
  overflow: hidden;
  font-size: 12px;
  width: 100%;
}

.childTitle:focus {
  font-weight: bold;
}

.locked {
  font-size: 80%;
  position: relative;
  top: -2px;
}

input[type='checkbox'] {
  opacity: 1;
  position: absolute;
  right: 0px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/DiaryTitle.vue